<template>
  <v-layout row wrap>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* App Name</label>
      </p>
      <v-text-field
        v-model="input.name"
        placeholder="App Name"
        dense
        hide-details
        outline
      />
      <small class="grey--text text--darken-2 ml-1">
        Any name from your choice
      </small>
    </v-flex>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* Phone Number</label>
      </p>
      <v-text-field
        v-model="input.phone_number"
        placeholder="Phone Number"
        dense
        hide-details
        outline
      />
    </v-flex>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* Phone Number ID</label>
      </p>
      <v-text-field
        v-model="input.phone_number_id"
        placeholder="Phone Number ID"
        dense
        hide-details
        outline
      />
    </v-flex>

    <v-flex xs12 v-if="!put">
      <p class="my-0">
        <label class="black--text">* App ID</label>
      </p>
      <v-text-field
        v-model="input.app_id"
        placeholder="App ID"
        dense
        hide-details
        outline
      />
    </v-flex>
    <v-flex xs12 v-if="!put">
      <p class="my-0">
        <label class="black--text">* App Secret</label>
      </p>
      <v-text-field
        v-model="input.app_secret"
        placeholder="App Secret"
        dense
        hide-details
        outline
      />
    </v-flex>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* Access Token</label>
      </p>
      <v-text-field
        v-model="input.access_token"
        placeholder="Access Token"
        dense
        hide-details
        outline
      />
      <small class="grey--text text--darken-2 ml-1">
        System User Access Token.
      </small>
    </v-flex>
    <v-flex xs12 v-if="!put">
      <p class="my-0">
        <label class="black--text">* WABA ID</label>
      </p>
      <v-text-field
        v-model="input.whatsapp_business_account_id"
        placeholder="Whatsapp Business Account ID"
        dense
        hide-details
        outline
      />
    </v-flex>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* Namespace</label>
      </p>
      <v-text-field
        v-model="input.namespace"
        placeholder="Namespace"
        dense
        hide-details
        outline
      />
      <small class="grey--text text--darken-2 ml-1">
        Ask your support team to get it.
      </small>
    </v-flex>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* Tier Limit</label>
      </p>
      <v-text-field
        v-model="input.tier_limit"
        placeholder="Tier Limit"
        type="number"
        @blur="handleTierLimitBlur"
        dense
        hide-details
        outline
      />
      <small class="grey--text text--darken-2 ml-1">
        The max number of message your account can send in a rolling 24-hour
        period.
      </small>
    </v-flex>
    <v-flex xs12>
      <p class="my-0">
        <label class="black--text">* Verify Token</label>
      </p>
      <v-text-field
        v-model="input.verify_token"
        placeholder="Verify Token"
        dense
        hide-details
        outline
      />
      <small class="grey--text text--darken-2 ml-1">
        Ask your support team to get it.
      </small>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "AddWhatsappApp",
  props: {
    put: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      input: {
        name: "",
        phone_number: "",
        phone_number_id: "",
        whatsapp_business_account_id: "",
        app_id: "",
        app_secret: "",
        access_token: "",
        namespace: "",
        tier_limit: 250,
        verify_token: "",
      },
    };
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
  },
  watch: {
    put: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          const c = val;
          if (c && c.tier_limit && c.tier_limit.toString) {
            c.tier_limit = val.tier_limit.toString();
          } else {
            c.tier_limit = "250";
          }
          this.input = c;
          this.handleTierLimitBlur();
        } else {
          this.input = {
            name: "",
            phone_number: "",
            phone_number_id: "",
            whatsapp_business_account_id: "",
            app_id: "",
            app_secret: "",
            access_token: "",
            namespace: "",
            tier_limit: 250,
            verify_token: "",
          };
        }
      },
    },
  },
  methods: {
    validateInput() {
      let keys = Object.keys(this.input);
      if (this.put) {
        keys = this.$_.pick(keys, [
          "name",
          "namespace",
          "tier_limit",
          "access_token",
          "verify_token",
        ]);
      }
      let i;
      for (i = 0; i < keys.length; i += 1) {
        if (this.input[keys[i]] !== null && this.input[keys[i]] !== undefined) {
          if (
            typeof this.input[keys[i]] === "string" &&
            !this.input[keys[i]].length
          ) {
            console.log(keys[i], 1);
            return false;
          }
        } else {
          console.log(keys[i], 2);
          return false;
        }
      }
      return true;
    },
    handleTierLimitBlur() {
      if (!this.input.tier_limit || !this.input.tier_limit.length) {
        this.input.tier_limit = "250";
      } else if (isNaN(this.input.tier_limit)) {
        this.input.tier_limit = "250";
      }
    },
    submit() {
      if (!this.validateInput()) {
        this.$store.dispatch(
          "setErrorMessage",
          "You are missing some mandatory fields to be filled, please fill them first and resubmit."
        );
        return;
      }
      let payload = this.$_.cloneDeep(this.input);
      payload.tier_limit = parseFloat(payload.tier_limit, 10);
      if (this.put) {
        payload = this.$_.omit(payload, [
          "tier_daily_consumed",
          "_id",
          "status",
          "connectable",
          "connected_with_app",
          "image",
        ]);
      }
      this.$emit("loading", true);

      if (this.put) {
        this.$http_session_manager
          .put(
            `/bots/${this.botId}/apps/whatsapp/${payload.phone_number_id}`,
            payload
          )
          .then((res) => {
            this.$emit("success", res.data);
            this.$emit("loading", false);
          })
          .catch((err) => {
            const msg =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message.error
                : true;
            this.$store.dispatch("setErrorMessage", msg);
            this.$emit("loading", false);
          });
      } else {
        this.$http_session_manager
          .post(`/bots/${this.botId}/apps/whatsapp`, [payload])
          .then((res) => {
            this.$emit("success", res.data);
            this.$emit("loading", false);
          })
          .catch((err) => {
            const msg =
              err.response && err.response.data && err.response.data.message
                ? err.response.data.message.error
                : true;
            this.$store.dispatch("setErrorMessage", msg);
            this.$emit("loading", false);
          });
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
